/**
 * Classe de manipulation de chaine de caractères
 */

import Number from '@classes/Number';

export default class Str {

    // Chaine de caractères à manipuler
    // value: null

    /**
     * Constructeur
     * @param string value Chaine de caractères à manipuler
     */
    constructor(value) {
        this.value = value;
    };

    /**
     * Converti la chaine en camelCase
     * @param string separator
     * @return string
     */
    toCamelCase(separator = '-') {
        const regex = new RegExp(separator + '.', 'g');
        return this.value.replace(regex, (m) => m[1].toUpperCase());
    };

    /**
     * Converti la chaine en snake-case
     * @param string separator
     * @return string
     */
    toSnakeCase(separator = '-') {
        return this.value.replace( /([A-Z])/g, " $1" ).split(' ').join(separator).toLowerCase();
    };

    /**
     * Retourne la chaine en mettant la première lettre en minuscule
     * @return string
     */
    toLowerCaseFirst() {
        return (this.value.charAt(0).toLowerCase() + this.value.slice(1));
    };

    /**
     * Retourne la chaine en mettant la première lettre en majuscule
     * @return string
     */
    toUpperCaseFirst() {
        return (this.value.charAt(0).toUpperCase() + this.value.slice(1));
    };

    /**
     * Retourne la chaine de caractères en limitant le nombre de mots
     * @param int maxWords
     * @param string ellipsis Caractères de substitution lorsque la chaine est trop longue
     * @return string
     */
    limitWords(maxWords, ellipsis = '...') {

        const currentString = this.value;

        const words = currentString.split(' ').map((word) => word.trim()).filter((word) => word !== '');
        if(words.length <= maxWords) {
            return currentString;
        }

        const wordsStr = words.slice(0, maxWords).join(' ');
        return (wordsStr + ellipsis);
    };

    /**
     * Retourne la chaine de caractères en limitant le nombre de caractères
     * @param int maxChars
     * @param string ellipsis Caractères de substitution lorsque la chaine est trop longue
     * @return string
     */
    limitChars(maxChars, ellipsis = '...') {
        let newString = '';

        const currentString = this.value;

        let tooLong = false;
        currentString.split(' ').forEach((word) => {
            //console.log(word);
            const nextNewString = newString + word + ' ';
            if(tooLong || nextNewString.length > maxChars) {
                tooLong = true;

                return;
            }

            newString += word + ' ';
        });

        if(newString.length < this.value.length) {
            newString += ellipsis;
        }

        return newString.trim();
    }

    /**
     * Retourne un identifiant unique
     * @return string
     */
    static uniqueId() {

        let intervalsByType = {
                'letter': { 'min': 97, 'max': 122 },
                'integer': { 'min': 48, 'max': 57 }
            },
            characterTypes = Object.keys(intervalsByType),
            iteration = Number.random(5, 10),
            identifiers = [],
            numberCharacters, characterType, intervals, i, j
        ;

        for(i = 0 ; i < iteration ; i++) {
            numberCharacters = Number.random(10, 20);
            for(j = 0 ; j < numberCharacters ; j++) {
                characterType = characterTypes[Number.random(0, characterTypes.length - 1)];

                intervals = intervalsByType[characterType];
                if(! identifiers[i]) {
                    identifiers[i] = '';
                }
                identifiers[i] += String.fromCharCode(Number.random(intervals['min'], intervals['max']));
            }
        }

        return identifiers.join('');
    };
}
